import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Container, Row, Col, Card, Modal,Button} from 'react-bootstrap';
import { pdfjs, Document, Page } from 'react-pdf';
import EdisPaymentService from '../../services/payments/PenaltyPaymentService.ts';
import 'react-pdf/dist/Page/TextLayer.css';
import 'react-pdf/dist/Page/AnnotationLayer.css'; // Optional but recommended
import { ProgressSpinner } from 'primereact/progressspinner';
import { FaLessThanEqual } from 'react-icons/fa';
import { Toast } from 'primereact/toast';
const MEDIA_URL = process.env.REACT_APP_STATIC_MEDIA_URL;
const JS_URL = process.env.REACT_APP_STATIC_JS_URL;

// Ensure that the workerSrc is set before rendering the PDF
pdfjs.GlobalWorkerOptions.workerSrc = `${JS_URL}pdf.worker.min.mjs`;
declare global {
  interface Window {
    tokenExpirationInterval: NodeJS.Timeout | null;
  }
}

const EdisPaymentProcessingComponent = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { formData, targetUrl, paymentMethod, email, outStandingAmount} = location.state || {};
  const [numPages, setNumPages] = useState<number >(0);
  const [loading, setLoading] = useState(false);
const toastRef = React.useRef<Toast>(null);
  const [showPopup, setShowPopup] = useState(false);
  const [remainingTime, setRemainingTime] = useState<number | null>(null);
  const [hasDismissedPopup, setHasDismissedPopup] = useState(false);
  const [tokenExpirationInterval, setTokenExpirationInterval] = useState<NodeJS.Timeout | null>(null);
  const [paymentDetails, setPaymentDetails] = useState(null);
const [pageWidth, setPageWidth] = useState(800);
const hasFetched = useRef(false);
const updateWidth = () => {
    const screenWidth = window.innerWidth;
    const calculatedWidth = screenWidth < 820 ? screenWidth - 32 : 800;
    setPageWidth(calculatedWidth);
  };
useEffect(() => {
  updateWidth();
    window.addEventListener('resize', updateWidth);
    return () => window.removeEventListener('resize', updateWidth);
  return () => {
    if (window.tokenExpirationInterval) {
      clearInterval(window.tokenExpirationInterval);
    }
  };
 
},[]);
 
  useEffect(() => {
     if (hasFetched.current) return; // ✅ prevent duplicate call

    hasFetched.current = true;
  if (!email || !paymentMethod || !outStandingAmount) {
    navigate("/");
    return;
  }

  const fetchPaymentDetails = async () => {
    setLoading(true);
    try {
      
      const paymentDetails = await EdisPaymentService.getPaymentRequest(email, paymentMethod, outStandingAmount);
      setPaymentDetails(paymentDetails);
       setLoading(false);
    } catch (error) {
      const status = error?.response?.status;
       setLoading(false);
      if (status === 401) {
        navigate('/paymenttokenexpired');
      } else {
         toastRef.current?.show({
            severity: 'error',
            summary: 'Error',
            detail: 'An error occurred. Please try again later.',
            life: 3000,
          });
      }
    }
  };

  fetchPaymentDetails();

}, [email, paymentMethod, outStandingAmount]); 
 const handlePopupClose = () => {
    setShowPopup(false);
    setHasDismissedPopup(true);
  };
if (loading) {
          return (
              <div className="d-flex justify-content-center align-items-center" style={{ height: '300px' }}>
                  <ProgressSpinner />
              </div>
          );
      }
  const handleClose = () => {
    navigate('/');  // Go back to the homepage
  };
  const handleExtendSession = async () => {
      try {
        const token = localStorage.getItem("paymentToken");
        const tokenresponse = await EdisPaymentService.refreshToken(formData.invoiceNumber, formData.referenceNumber);
        
        if (tokenresponse.data.tokenExpiration) {
         
          localStorage.setItem("paymentTokenExpiration", tokenresponse.data.tokenExpiration);
          setShowPopup(false);
          setHasDismissedPopup(false);
          if (window.tokenExpirationInterval) {
            clearInterval(window.tokenExpirationInterval);
          }
          startTokenExpirationTimer(tokenresponse.data.tokenExpiration);
        }
      } catch (error) {
        console.error('Error extending the session:', error);
         setShowPopup(false);
          setHasDismissedPopup(false);
          alert("Error Occured while Extended session.");
      }
    };
  
    const startTokenExpirationTimer = (expirationTime) => {
      if (!expirationTime) return;
  
      console.log("Token Expiration Time:", expirationTime);
  
      const expirationTimestamp = new Date(expirationTime).getTime();
      const twoMinutesBefore = expirationTimestamp - 2 * 60 * 1000;
  
      if (window.tokenExpirationInterval) {
        clearInterval(window.tokenExpirationInterval);
      }
  
      window.tokenExpirationInterval = setInterval(() => {
        const currentTime = new Date().getTime();
       
        if (currentTime >= twoMinutesBefore && currentTime < expirationTimestamp && !hasDismissedPopup) {
          setShowPopup(true);
          console.log("Session expiring in 2 minutes. Popup triggered.");
        }
  
        if (currentTime >= expirationTimestamp) {
          clearInterval(window.tokenExpirationInterval as unknown as number);
          handleClose();
          console.log("Session expired. Timer stopped.");
        }
      }, 1000);
    };
  const handleOk = () => {
    setLoading(true);
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = targetUrl;
    Object.entries(paymentDetails).forEach(([key, value]) => {
      
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = value;
      form.appendChild(input);
    });
    // Append the form to the document body and submit it
    document.body.appendChild(form);
    form.submit();
    setLoading(false);
  };
  const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
    
    setNumPages(numPages);
  };

  return (
    <div className="edispayment-container">
       <Toast ref={toastRef} />
      {showPopup && !hasDismissedPopup && (
        <Modal show={showPopup} onHide={handlePopupClose} centered>
          <Modal.Header closeButton style={{ backgroundColor: '#0A3161', color: 'white' }}>
            <Modal.Title>Session Expiring Soon</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Your session is expiring in 2 minutes! Please proceed to complete your payment.</p>
          </Modal.Body>
          <Modal.Footer>
            <Button style={{ backgroundColor: '#0A3161' }} onClick={handleExtendSession}>
              Extend Session
            </Button>
            <Button style={{ backgroundColor: '#0A3161' }} onClick={handlePopupClose}>
              OK
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      <Row className="justify-content-center ">

        <Col xs={12} md={8} className="text-center">
          <Card className="col-md-12 card-section mt-4 mx-auto" style={{ maxWidth: '100%', position: 'relative' }}>
            <div className="justify-content-center " style={{ backgroundColor: '#b31942', padding: '10px' }}>
              <Col xs="auto" className="text-start">
                <h5 className="text-white">SBWC Electronic Payments</h5>
              </Col>
            </div>
<div className="pdf-container">
      <Document
        file={`${MEDIA_URL}terms-and-conditions.pdf`}
        onLoadSuccess={onDocumentLoadSuccess}
        loading="Loading PDF..."
      >
         {Array.from({ length: numPages }, (_, index) => (
          <div
            key={index}
            className={`pdf-page-wrapper ${index < numPages - 1 ? 'with-break' : ''}`}
          >
            <Page
              pageNumber={index + 1}
              width={pageWidth}
              renderAnnotationLayer={false}
              renderTextLayer={false}
               scale={window.devicePixelRatio || 1} // <<< improves clarity on mobile
            />
          </div>
        ))}
      </Document>
    </div>
            <Row className="justify-content-center mt-3">
              <Col xs="auto" className="mb-2">
                <Button
                   variant="light"
                 
                  onClick={handleClose}>Cancel</Button>
              </Col>
              <Col xs="auto" className="mb-2">
              <Button

  onClick={handleOk}
  disabled={loading}
  style={{ backgroundColor: '#0A3161' }}
>
  {loading ? 'Loading...' : 'I Agree'}
</Button>

              </Col>
            </Row>
       
      </Card>
    </Col>
      </Row >

    </div >
  );
};

export default EdisPaymentProcessingComponent;
